/*eslint-env jquery*/
import React, { Component } from 'react'
// import ReactTestUtils, { ReactDOM } from 'react-dom'
// import PropTypes from 'prop-types'
import moment from 'moment-jalaali' // Notice here !
import { DatetimePickerTrigger } from 'imrc-datetime-picker'
import MaskedInput from 'react-text-mask'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
// import Loading from '../Shared/Loading'
import { IoIosCloseCircleOutline } from 'react-icons/io'

moment.loadPersian({
  dialect: "persian-modern",
  usePersianDigits: false
});

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy/mm/dd');

class DatePicker extends Component {

  constructor(props) {
    super(props);
    this.state = {
      _moment: moment(),
      defaultValue: this.props.defaultValue,
      cleared: true,
      loading: true,
      // value: this.props.defaultValue ?
      //   this.formatDefaultValue(this.props.defaultValue) : ''
    };


    // // console.log(this.props.defaultValue)
  }

  async componentDidMount() {
    this.props.defaultValue &&
      await this.formatDefaultValue(this.props.defaultValue);
  }

  async componentWillReceiveProps(nextProps) {
    // // console.log("here1")
    if (nextProps.defaultValue && moment(nextProps.defaultValue).isValid()) {
      // // console.log("hecre2")
      await this.formatDefaultValue(nextProps.defaultValue);
    }
  }

  formatDefaultValue = async (e) => {
    if (e !== '0001-01-01T00:00:00') {
      let m = moment(e.split("T")[0], 'YYYY-MM-DD');
      const momentValue = moment(e.split("T")[0], 'YYYY-MM-DD');
      if (momentValue.isValid()) {
        await this.setState({ inputValue: momentValue.format("jYYYY/jMM/jDD"), _moment: m, loading: false, cleared: false });
      }
    }
  }

  handleChange = (selectedMoment) => {
    const inputValue = selectedMoment;
    const momentValue = inputValue.format("jYYYY/jMM/jDD");

    this.setState({
      inputValue: momentValue,
      _moment: selectedMoment,
      cleared: false
    });

    const val = selectedMoment.format("YYYY-MM-DD");
    this.props.onChange(val);

    // if (moment(val, "YYYY-MM-DD").isValid()) {
    //   // // console.log(val);
    //   this.dispatchEventChange(inputValue);
    // }

  }

  dispatchEventChange = (val) => {
    var element = this.node;
    var ev = new Event('input', { bubbles: true });
    ev.simulated = true;
    element.value = val;
    element.dispatchEvent(ev);

  }

  handleInputChange = (event) => {
    const inputValue = event.target.value;
    const momentValue = moment(inputValue, 'jYYYY-jMM-jDD');

    this.setState({ inputValue, cleared: true });

    if (momentValue.isValid()) {
      this.setState({ _moment: momentValue, cleared: false });

      const val = momentValue.format("YYYY-MM-DD");
      this.props.onChange(val);

      // // console.log(inputValue);
      // this.dispatchEventChange(momentValue);

    }
  }

  handleInputRemove = (e) => {
    e.stopPropagation()

    this.setState({ inputValue: null });
    this.props.onChange(null);
  }


  render() {
    const { _moment, cleared, inputValue } = this.state;

    const { name, onChange, handleBlur, disabled, minDate, maxDate, tabIndex, clearable, className } = this.props;

    const newMoment = moment();


    // var value = !cleared && _moment ? _moment.format("jYYYY/jMM/jDD") : "";

    return (
      <div className={className ? '' : "datepicker"}>

        <DatetimePickerTrigger
          tabIndex={tabIndex}
          disabled={disabled}
          moment={_moment}
          onChange={this.handleChange}
          isSolar={true}
          lang={"fa"}
          showTimePicker={false}
          closeOnSelectDay={true}
          minDate={minDate}
          maxDate={maxDate}
        >

          <div style={{ position: 'relative' }}>
            <MaskedInput
              tabIndex={tabIndex}
              disabled={disabled}
              className={className ? className : "date-input dateFa"}
              showMask={false}
              value={inputValue}
              onChange={this.handleInputChange}
              onBlur={handleBlur}
              mask={[/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/]}
            />
            {clearable && inputValue && <IoIosCloseCircleOutline className="date-picker-delete-btn" size="24px" color="#868686"
              onClick={(e) => this.handleInputRemove(e)} />}
          </div>
        </DatetimePickerTrigger>

        <input type="text" className="hidden" value={!cleared && _moment ? _moment.format("YYYY-MM-DD") : ""} name={name}
          onChange={onChange} ref={(value) => { this.node = value }} />

      </div>
    );
  }
}
export default DatePicker;
